import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Headers, Http } from '@angular/http';
import { UserService } from 'shared/services/User/user.service';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';



@Injectable()
export class PaymentService {
  constructor(private http: Http, private us: UserService, private router: Router) {
  }

  startGroupDeposit(checkout_total, tok, order_number, team_id) {
    const url = environment.API_BASE_URL + '/payment/startGroupDeposit';
    const headers = new Headers();
    headers.append('token', this.us.user.token);
    const params = new FormData();
    params.append('charge_token', tok);
    params.append('order_number', order_number);
    params.append('team_id', team_id);
    params.append('amount', checkout_total);
    return this.http.post(url, params, { headers: headers }).map(res => res.json())
      .catch(err => {
        return Observable.throw(err.json().error);
      });
  }

  joinGroupDeposit(checkout_total, tok, order_number, group_code) {
    const url = environment.API_BASE_URL + '/payment/joinGroupDeposit';
    const headers = new Headers();
    headers.append('token', this.us.user.token);
    const params = new FormData();
    params.append('charge_token', tok);
    params.append('amount', checkout_total);
    params.append('order_number', order_number);
    params.append('group_code', group_code);

    return this.http.post(url, params, { headers: headers }).map(res => {
      return res.json();
    })
      .catch(err => {
        console.log(err);
        return Observable.throw(err.json());
      });
  }

  connectStripeAccount(stripe_token) {
    const url = environment.API_BASE_URL + '/payment/connect';
    const headers = new Headers();
    headers.append('token', this.us.user.token);
    const params = new FormData();
    params.append('stripe_token', stripe_token);
    return this.http.post(url, params, { headers: headers }).map(res => res.json())
      .catch(err => {
        return Observable.throw(err.json().error);
      });
  }

  joinPublicGroup(chargeToken, order_number, group_id, amount, promoCode) {
    const url = environment.API_BASE_URL + '/payment/joinPublic';
    const headers = new Headers();
    headers.append('token', this.us.user.token);
    const params = new FormData();
    params.append('order_number', order_number);
    params.append('group_id', group_id);
    params.append('amount', amount);
    params.append('stripe_token', chargeToken);
    if(promoCode!=false){
      params.append('promo_code', promoCode);
    }
    return this.http.post(url, params, { headers: headers }).map(res => res.json())
      .catch(err => {
        return Observable.throw(err.json());
      });
  }

  checkPromo(groupId, promoCode) {
    const url = environment.API_BASE_URL + '/payment/checkPublicPromo';
    const headers = new Headers();
    headers.append('token', this.us.user.token);
    const params = new FormData();
    params.append('promo_code', promoCode);
    params.append('public_group_id', groupId);
    return this.http.post(url, params, { headers: headers }).map(res => res.json())
      .catch(err => {
        console.log(err);
        return Observable.throw(err.json());
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/Payment/payment.service.ts